<template>
  <!-- @blur="open = false" -->
  <div class="custom-select" :tabindex="tabindex">
    <div class="items" :class="{ selectHide: !isOpen }">
      <div
        class="p-2 text-truncate"
        v-for="(option, i) of options"
        :key="option+i"
        @click=" $emit('addAndTag', option) "
      >
        {{ option }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return { };
  },
  mounted() { },
  watch:{ }
};
</script>


<style scoped>
.custom-select {
  position: absolute;
  width: 180%;
  text-align: left;
  outline: none;
  max-height: 300px;
  max-width: 280px;
}


.custom-select .items {
  max-height: 300px;
  border-radius: 0px 0px 6px 6px;
  overflow: auto;
  border: 1px solid #e8e8e8;
  position: absolute;
  background-color: #fff;
  padding: 0px;
  left: 0;
  right: 0;
  z-index: 99;
}

.custom-select .items div {
  font-family: 'Roboto', 'Kanit', sans-serif ;
  color: black;
  font-size: 16px;
  padding: 12px;
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
}

.custom-select .items div:hover {
  background-color: rgb(65, 184, 131);
  color: #fff;
}

.selectHide {
  display: none;
}
</style>




// WEBPACK FOOTER //
// src/components/elements/SelectTag.vue